(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-accordeon"] && !Shopify.designMode) return;
  try {
    
(function () {
    const galleryTextSlide = () => {
        const cards = document.querySelectorAll('.gallery-with-text__card');
        const isMobile = window.innerWidth < 990;
        
        // Activar el primer card al cargar
        if (cards.length > 0) {
            cards[0].classList.add('active');
            const firstOverlay = cards[0].querySelector('.gallery-with-text__info .link--overlay');
            if (firstOverlay) {
                firstOverlay.classList.add('active');
            }
        }

        cards.forEach(card => {
            const title = card.querySelector('.gallery-with-text__title');
            
            if (isMobile) {
                // Mobile: click en el título para acordeón
                title.addEventListener('click', function(e) {
                    e.preventDefault();
                    const isActive = card.classList.contains('active');
                    
                    // Toggle del card actual
                    if (isActive) {
                        card.classList.remove('active');
                        const overlay = card.querySelector('.gallery-with-text__info .link--overlay');
                        if (overlay) {
                            overlay.classList.remove('active');
                        }
                    } else {
                        card.classList.add('active');
                        setTimeout(() => {
                            const overlay = card.querySelector('.gallery-with-text__info .link--overlay');
                            if (overlay) {
                                overlay.classList.add('active');
                            }
                        }, 100);
                    }
                });
            } else {
                // Desktop: hover como antes
                card.addEventListener('mouseenter', function() {
                    this.classList.add('active');
                    cards.forEach(sibling => {
                        if (sibling !== this) {
                            sibling.classList.remove('active');
                        }
                    });

                    setTimeout(() => {
                        const overlay = this.querySelector('.gallery-with-text__info .link--overlay');
                        if (overlay) {
                            overlay.classList.add('active');
                        }

                        cards.forEach(sibling => {
                            if (sibling !== this) {
                                const siblingOverlay = sibling.querySelector('.gallery-with-text__info .link--overlay');
                                if (siblingOverlay) {
                                    siblingOverlay.classList.remove('active');
                                }
                            }
                        });
                    }, 100);
                });
            }
        });
    };

    // Re-inicializar en resize para cambiar entre mobile/desktop
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            // Limpiar listeners anteriores
            const cards = document.querySelectorAll('.gallery-with-text__card');
            cards.forEach(card => {
                const newCard = card.cloneNode(true);
                card.parentNode.replaceChild(newCard, card);
            });
            galleryTextSlide();
        }, 250);
    });

    document.addEventListener('shopify:section:load', galleryTextSlide);
    galleryTextSlide();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
